// a very rough English-to-Proto-Indo-European dictionary,
// data scraped from https://academiaprisca.org/en/resources/etymological-lexicon-proto-indo-european-language/
// de-duped (mostly random which one was picked), much context lost
export let en_to_PIE: Record<string, string> = {};

/** set the PIE dictionary */
export function setPIEDictionary(data: Record<string, string>) {
  en_to_PIE = data;
}
